export default "__VITE_ASSET__BelNh6Wv__"